{% import Exception from './exception' %}

<div class="executable-fragment-wrapper{{ theme ? ' theme-' + theme + '-wrapper' : '' }}{{ shorterHeight ? ' executable-fragment-wrapper_gutter' : '' }}">
    <div class="executable-fragment {{ theme }}">
      {% if (!highlightOnly) %}
        <div class="run-button {{ waitingForOutput ? '_disabled' : ''}}" data-track-run-id="{{ dataTrackRunId || '' }}"
          :onclick={{ this.execute.bind(this) }}></div>
      {% endif %}
        <div class="code-area {{ folded ? '_folded' : '_unfolded' }}">
            {% if (isShouldBeFolded) %}
                <div class="fold-button {{ foldButtonHover ? '_hover' : '' }} {{ theme }}"
                    :onclick={{ this.onFoldButtonClick.bind(this) }}
                    :onmouseenter={{ this.onFoldButtonMouseEnter.bind(this) }}
                    :onmouseleave={{ this.onFoldButtonMouseLeave.bind(this) }}>
                </div>
            {% endif %}
            <textarea></textarea>
        </div>
        <div class="js-code-output-executor {{ theme }}">
          {% if (openConsole) %}
            <div class="console-close {{ theme }}" :onclick={{ this.onConsoleCloseButtonEnter.bind(this) }}></div>
          {% endif %}
          {% if (waitingForOutput) %}
              <div class="output-wrapper {{ theme }}">
                <div class="loader {{ theme }}"></div>
              </div>
          {% else %}
              {% if (output && output != "") || exception %}
                  <div class="output-wrapper {{ theme }}">
                      <div class="code-output">
                          {% unsafe output %}

                          {% if exception %}
                              <Exception
                                {{...exception}}
                                originalException={{ true }}
                                onExceptionClick={{ this.onExceptionClick.bind(this) }}
                              />
                          {% endif %}
                      </div>
                  </div>
              {% endif %}
          {% endif %}
        </div>
    </div>

    {% if (!highlightOnly) %}
        <div class="compiler-info{{ crosslink ? ' compiler-info_crosslink' : '' }}" data-nosnippet>
            {% if (crosslink) %}
              <div class="compiler-info__open-editor">
                <a class="compiler-info__open-editor-link" href="{{ crosslink }}" target="_blank" rel="noopener noreferrer">Open&nbsp;in&nbsp;Playground&nbsp;→</a>
              </div>
            {% endif %}
            <span class="compiler-info__target">Target: {{ targetPlatform.printableName }}</span>
            <span class="compiler-info__version">Running on v.{{ compilerVersion }}</span>
        </div>
    {% endif %}
    {% if (shorterHeight) %}<button class="executable-fragment-wrapper__shorter" :onclick={{ this.onShorterClick.bind(this) }}>more</button>{% endif %}
</div>
